import React from "react";
import { connect } from "react-redux";

import { Input, TextArea } from "components";
import { TAB_5B_UPDATE_INVOICE, TAB_5B_INVOICE_AUTOFILL } from "actions";

const CustomerItem = props => {
  const { domain, companyName, autoFilled, updateInvoice, companyAddress, companyNumber, highestAmountOwing } = props;
  return (
    <div className="invoice_slide" data-merge="1">
      <div className="inner_slide">
        <div className="invoice_slide--title">
          <h4>{companyName}</h4>
        </div>
        <div className="invoice_slide--caption">
          {!autoFilled && (
            <React.Fragment>
              <div>
                <label>{domain.Strings.tab5BCarouselAddressLabel}</label>
                <TextArea onChange={updateInvoice} name="companyAddress" value={companyAddress} placeholder={domain.Strings.tab5BCarouselAddressPlaceholder} />
              </div>
              <div>
                <label>{domain.Strings.tab5BCarouselRegNumberLabel}</label>
                <Input onChange={updateInvoice} name="companyNumber" value={companyNumber} placeholder={domain.Strings.tab5BCarouselRegNumberPlaceholder} />
              </div>
            </React.Fragment>
          )}

          <div>
            <label>{domain.Strings.tab5BCarouselAmountOwedLabel}</label>
            <Input prefix={props.domain.Currency} addCommas onChange={updateInvoice} type="number" name="highestAmountOwing" value={highestAmountOwing} placeholder={domain.Strings.tab5BCarouselAmountOwedPlaceholder} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  const { i } = ownProps;
  return {
    ...state.app.customers.find((_, index) => index === i),
    domain: state.app.domain
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const { i } = ownProps;
  return {
    triggerAutoFill: () => dispatch({ type: TAB_5B_INVOICE_AUTOFILL, i }),
    updateInvoice: data => dispatch({ type: TAB_5B_UPDATE_INVOICE, index: i, ...data })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerItem);
